import React from 'react';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { combineReducers } from 'redux-immutable';
import DataManager from '@americanexpress/data-manager';
import SharedScripts, { Adobe } from '@americanexpress/shared-scripts';
import { AmexDDLRegister, getAmexDataManagerConfig } from '@americanexpress/data-manager-utils';
import { DDLRegister } from '@americanexpress/react-ddl';
import childRoutes from '../childRoutes';
import { rootReducer } from '../ducks';
import ErrorReporter from './error/ErrorReporter';

const AxpPeerPaymentsPayAnyBankRoot = ({
  children,
  dispatch,
}) => (
  <React.Fragment>
    <Helmet
      {...{
        htmlAttributes: { lang: 'en' },
        link: [
          {
            rel: 'stylesheet',
            href: 'https://www.aexp-static.com/cdaas/one/statics/axp-dls/6.8.0/package/dist/6.8.0/styles/dls.min.css',
          },
          {
            rel: 'canonical',
            href: 'https://consumer-payments-qa.americanexpress.com/p2p-us/paba/',
          },
        ],
        script: [
          {
            type: 'text/javascript',
            src: 'https://www.aexp-static.com/cdaas/one/statics/axp-dls/6.1.0/package/dist/6.1.0/scripts/dls.min.js',
          },
        ],
        title: 'Claim Money',

        meta: [
          { name: 'viewport', content: 'width=device-width, initial-scale=1' },
          { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
          { name: 'application-name', content: 'American Express' },
          { charset: 'utf-8' },
          { name: 'theme-color', content: '#006FCF' },
          { name: 'msapplication-TileImage', content: '' },

          { property: 'og:site_name', content: 'Tap to claim' },
          { property: 'og:image', content: 'https://qicm.aexp-static.com/Internet/IMDC/p2p/images/PABA-share.gif', key: 'og:image' },
          { property: 'og:image:width', content: '1080' },
          { property: 'og:image:height', content: '1350' },
          { property: 'og:image:alt', content: 'Tap to claim' },
          { property: 'og:image:type', content: 'image/png' },

          { property: 'twitter:image', content: 'https://qicm.aexp-static.com/Internet/IMDC/p2p/images/PABA-share.gif', key: 'twitter:image' },
          { property: 'twitter:site', content: '@paba' },

          { name: 'description', content: 'FREE' },

          { property: 'og:title', content: 'Tap to claim' },
          { property: 'og:description', content: 'Tap to claim' },

          { property: 'og:type', content: 'website' },

          { property: 'og:url', content: 'https://qicm.aexp-static.com/Internet/IMDC/p2p/images/PABA-share.gif' },
        ],
      }}
    />
    {/* eslint-disable react/jsx-props-no-spreading */}
    <DataManager {...getAmexDataManagerConfig({ initialDDL: { historyLimit: 70 } })}>
      <AmexDDLRegister />
      <DDLRegister name="user.authenticated" value={false} />
      <Adobe version="0.1.0" />
      <SharedScripts
        name="one-stream-data-handler"
        windowCheck="oneStreamData"
        version="^0.1.0"
      />
      <ErrorReporter dispatch={dispatch} />
      <div data-module-name="axp-peer-payments-pay-any-bank-root">
        {children}
      </div>
    </DataManager>
  </React.Fragment>
);
export const TestableAxpPeerPaymentsPayAnyBankRoot = AxpPeerPaymentsPayAnyBankRoot;

AxpPeerPaymentsPayAnyBankRoot.propTypes = {
  children: PropTypes.node.isRequired,
  dispatch: PropTypes.func.isRequired,
};

AxpPeerPaymentsPayAnyBankRoot.childRoutes = childRoutes;

/* istanbul ignore next */
if (!global.BROWSER) {
  // eslint-disable-next-line global-require -- require needs to be inside browser check
  AxpPeerPaymentsPayAnyBankRoot.appConfig = require('../appConfig').default;
}

export const loadModuleData = ({ store: { dispatch } }) => dispatch(
  loadLanguagePack('axp-peer-payments-pay-any-bank-root', {
    fallbackLocale: 'en-US',
  })
);

AxpPeerPaymentsPayAnyBankRoot.holocron = {
  name: 'axp-peer-payments-pay-any-bank-root',
  loadModuleData,
  reducer: combineReducers({
    rootReducer,
  }),
};

export default oneAppModuleWrapper('axp-peer-payments-pay-any-bank-root')(
  AxpPeerPaymentsPayAnyBankRoot
);
